import useDocumentCreator from "../../../engine/hooks/useDocumentCreator";
import dayjs from "../../../utils/dayjs";
import {
  daysJsFormat,
  languagesList,
  renderStatusLabels,
  renderTypePrestation,
  renderUserName,
  roles,
} from "../../../utils/constants";
import { Excel } from "antd-table-saveas-excel";
import { Button, Space } from "antd";
import { AiFillFileExcel } from "react-icons/ai";
import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { FilePdfOutlined } from "@ant-design/icons";
import {
  createXMLString,
  downloadStringFileXml_CSV,
} from "../../../utils/bills.xml";
import { http } from "../../../engine/api/http";
import { BsFiletypeXml } from "react-icons/bs";
import { TbFileTypeXml, TbFileTypePdf } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { ActionDropdown } from "../../../shared/components/ActionDropdown/ActionDropdown";
import { FcCancel } from "react-icons/fc";
import { UserContext } from "../../../engine/context/User.context";
import routes from "../../../engine/routes";
import { useNavigate } from "react-router-dom";
import { onlyRoleMapping } from "../../../engine/AuthRoute";
import { BillsExportsExcel } from "./BillsExportsExcel";

export const BillsExportFile = ({ type, selectedRowKeys, isExternal }) => {
  const { t, i18n } = useTranslation();
  const [get, createAndGet, isLoading, setUrl, doc] = useDocumentCreator();

  const [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();

  const exportPDF = () => {
    createAndGet(
      { ids: selectedRowKeys, language: i18n.language },
      `bills/pdfs`,
      true,
      true,
      () => {},
    );
  };

  const exportXML = async bills => {
    try {
      // const loggit = await http.post("/logs", {
      //   baseUrl: "/api/bills",
      //   action: "export",
      //   route: "/api/bills/xml",
      //   ressource: "/api/bills/xml",
      //   content: {
      //     billsId: selectedRowKeys,
      //   },
      // });

      const xmlString = createXMLString({
        bills,
      });
      downloadStringFileXml_CSV(xmlString, "bills.xml", "application/xml");
    } catch (e) {
      console.log(e);
    }
  };

  const exportExcel = async bills => {
    try {
      const loggit = await http.post("/logs", {
        baseUrl: "/api/bills",
        action: "export",
        route: "/api/bills/xlxs",
        ressource: "/api/bills/xlxs",
        content: {
          billsId: selectedRowKeys,
        },
      });

      let prestations = [];

      let copy = _.cloneDeep(bills);

      copy
        .filter(e => {
          if (selectedRowKeys !== null) {
            return selectedRowKeys.includes(e._id);
          } else {
            return true;
          }
        })
        .map(bill => {
          bill.prestations.map(presta => {
            presta.bill = bill;
            presta.bill.institution = presta.institution;
            if (presta.bill !== null) {
              presta.bill.intitution = presta.institution;
            }
            prestations.push(presta);
          });
        });

      await BillsExportsExcel(prestations, false);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const getDataBeforeExport = async () => {
    try {
      const billsToExport = await http.post(
        `/bills/exports?advancedCols=true&${
          isExternal ? "isExternal=true" : "isExternal=false"
        }`,
        {
          selectedRowKeys,
        },
      );
      return billsToExport.data.bills;
    } catch (e) {
      console.log(e);
    }
  };

  const isDisabled = selectedRowKeys.length === 0;

  return (
    <Space>
      <ActionDropdown loading={loading || isLoading}>
        {onlyRoleMapping([roles.admin, roles.permanance]) ? (
          <a
            loading={loading}
            disabled={isDisabled}
            style={{ opacity: isDisabled ? 0.8 : 1 }}
            onClick={() => {
              navigate(routes.billing().camt.path);
            }}
          >
            <span style={{ marginLeft: 5, marginRight: 10 }}>
              <TbFileTypeXml color={"red"} size={20} />
            </span>
            {t("BillsExportFile.importCamt")}
          </a>
        ) : null}

        {onlyRoleMapping([roles.admin, roles.permanance]) ? (
          <a
            loading={loading}
            disabled={isDisabled}
            style={{ opacity: isDisabled ? 0.8 : 1 }}
            onClick={async () => {
              if (!isDisabled) {
                setLoading(true);
                let bills = await getDataBeforeExport();
                await exportExcel(bills);
              }
            }}
          >
            <span style={{ marginLeft: 5, marginRight: 10 }}>
              <AiFillFileExcel color={"red"} size={20} />
            </span>
            {t("BillsExportFile.exportXLSX")}
          </a>
        ) : null}
        <a
          loading={isLoading}
          disabled={selectedRowKeys.length === 0}
          onClick={() => !isDisabled && exportPDF()}
          style={{ opacity: isDisabled ? 0.8 : 1 }}
        >
          <span style={{ marginLeft: 5, marginRight: 10 }}>
            <TbFileTypePdf color={"red"} size={20} />
          </span>
          {t("BillsExportFile.exportPDF")}
        </a>

        {onlyRoleMapping([roles.admin, roles.permanance]) ? (
          <a
            style={{ opacity: isDisabled ? 0.8 : 1 }}
            disabled={selectedRowKeys.length === 0}
            onClick={async () => {
              let bills = await getDataBeforeExport();
              await exportXML(bills);
            }}
          >
            <span style={{ marginLeft: 5, marginRight: 10 }}>
              <TbFileTypeXml color={"red"} size={20} />
            </span>
            {t("BillsExportFile.exportXML")}
          </a>
        ) : null}
      </ActionDropdown>
    </Space>
  );
};
